import { call, put, takeLatest } from 'redux-saga/effects'
import { select } from '@redux-saga/core/effects'
import { setPatientSignature } from '../store/signatures.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { SignaturesConstants } from '../store/signatures.constants'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* getPatientSignature() {
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrId: string = yield select(getPcrIdSelector)

  if (!pcrId) {
    return
  }
  try {
    const pcr: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrId)
    if (pcr._attachments) {
      if (pcr._attachments.StandardSignatures_Section1_Patient !== undefined) {
        const patientSignature = pcr._attachments.StandardSignatures_Section1_Patient
        const signature = document.createElement('img')
        signature.src = 'data:' + patientSignature.fileExtension + ';base64,' + patientSignature.data
        yield put(setPatientSignature(signature.src))
      } else {
        yield put(setPatientSignature(null))
      }
    } else {
      yield put(setPatientSignature(null))
    }
  } catch (e) {
    yield put(throwPcrException(`getPatientSignature() error: ${e}`))
  }
}

export function* getPatientSignatureSaga() {
  yield takeLatest([SignaturesConstants.GET_SIGNATURES], performWithMutexHOG, getPatientSignature)
}
